<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue">
<h1>Prologue</h1>
<p style="text-indent:0em">A strong woman is one who feels deeply and loves fiercely.</p>
<p style="text-indent:0em">Her tears flow just as abundantly as her laughter.</p>
<p style="text-indent:0em">A strong woman is both soft and powerful.</p>
<p style="text-indent:0em">She is both practical and spiritual.</p>
<p style="text-indent:0em">A strong woman in her essence is a gift to the world.</p><br/>
<p style="text-indent:0em">Ritu Ghatourey</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?14ddaf94